var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '@app/utility/api.service';
var NewsComponent = /** @class */ (function () {
    function NewsComponent(activatedRoute, apiService, router) {
        this.activatedRoute = activatedRoute;
        this.apiService = apiService;
        this.router = router;
        this.isCrisis = false;
        this.newsId = "";
        this.news = {};
    }
    NewsComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var config, crisisConfig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"));
                        if (this.cookieData == null) {
                            this.cookieData = {};
                        }
                        this.isCrisis = this.cookieData.isCrisis;
                        return [4 /*yield*/, this.apiService.get("master", "configuration")];
                    case 1:
                        config = _a.sent();
                        crisisConfig = config.filter(function (c) {
                            return c.dpa_name == "CRISIS FLAG";
                        });
                        if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
                            this.isCrisis = true;
                        }
                        else {
                            this.isCrisis = false;
                        }
                        this.newsId = this.activatedRoute.snapshot.paramMap.get('id');
                        return [4 /*yield*/, this.getNews()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NewsComponent.prototype.getNews = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var para, newsList, newsFound;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "dpa_publishstatus=true&dpa_isdisplayoncustomerportal=true&dpa_iscrisis=" + this.isCrisis.toString();
                        return [4 /*yield*/, this.apiService.get("crmservice", "news", para)];
                    case 1:
                        newsList = _a.sent();
                        newsFound = newsList.filter(function (n) {
                            return n.dpa_newandactivityid == _this.newsId;
                        });
                        if (newsFound != null && newsFound.length > 0) {
                            this.news = newsFound[0];
                        }
                        else {
                            this.news = {};
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    NewsComponent.prototype.goToHome = function () {
        this.router.navigate(["mainmenu/index"]);
    };
    return NewsComponent;
}());
export { NewsComponent };



// WEBPACK FOOTER //
// ./src/app/news/news.component.ts.pre-build-optimizer.js